/**
 * Suggested path for one book: approved sequences, drafted scenes, and the
 * next step. Free; read from saved state.
 */
import { api } from './client';

const unwrap = (res) => (res?.data?.data ?? res?.data ?? res);

export async function getBookPath(storyId) {
  return unwrap(await api.get(`/stories/${storyId}/next-step`, { cache: 'no-store' }));
}
